export { default } from "./NewsList";
